import { Component, Vue } from "vue-property-decorator";

import template from "./error.vue";

/**
 * Page de connexion
 */
@Component({
  mixins: [template],
})
export default class Error extends Vue {}
